export default __webpack_public_path__ + "a989023e7098144e49c2e11d22267b44.png";